import { Collapsible } from "./Collapsible.js";

export class CollapsibleManager {
    private static manager: CollapsibleManager;
    private instances: Collapsible[] = [];

    private constructor() {
        document
            .querySelectorAll<HTMLElement>("[collapsible]")
            .forEach((container) => {
                const ids = Array.from(
                    container.querySelectorAll<HTMLElement>("[aria-controls]"),
                )
                    .map((controller) =>
                        controller.getAttribute("aria-controls"),
                    )
                    .filter((id): id is string => id !== null);
                const collapsibles = ids.map((id) =>
                    Collapsible.create(id, container),
                );
                this.instances.push(...collapsibles);
                this.observeExpandedMode(container, collapsibles);
            });
    }

    public static use(reset: boolean = false): CollapsibleManager {
        if (!CollapsibleManager.manager || reset)
            CollapsibleManager.manager = new CollapsibleManager();
        return CollapsibleManager.manager;
    }

    public get length(): number {
        return this.instances.length;
    }

    private observeExpandedMode(
        container: HTMLElement,
        collapsibles: Collapsible[],
    ): void {
        const expandedAt = Number(
            container.getAttribute("data-collapsible-expanded-at"),
        );
        if (
            !Number.isFinite(expandedAt) ||
            expandedAt <= 0 ||
            !("ResizeObserver" in window)
        )
            return;

        let isExpanded: boolean | undefined;
        const update = (): void => {
            const expanded = container.clientWidth >= expandedAt;
            if (expanded === isExpanded) return;

            isExpanded = expanded;
            collapsibles.forEach((collapsible) =>
                collapsible.setExpandedMode(expanded),
            );
        };

        new ResizeObserver(update).observe(container);
        update();
    }
}
